//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'RevisedTraumaScore',
  data () {
    return {
      defaultJson: {
        "RTS %@": "RTS %@",
        "Respiratory Rate": "呼吸频率",
        "Systolic BP": "收缩压",
        "Refer to trauma center": "求助创伤中心",
        "Glasgow Coma Scale": "Glasgow 昏迷评分",
        "Enter 0 if you have no reading.": "如无读数，输入 0。",
        "GCS": "GCS"
      },
      form: {
        gcs:'',
        sbp:'',
        rr:'',
      },
      hasScore: false,
      disabled: false,
      descTxt:'',
      g:'',
      p:'',
      r:'',
      rts:'--'
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form)
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        console.log(form)
        	// gcs <= 3 ? 0 : (gcs <= 5 ? 1 : (gcs <= 8 ? 2 : (gcs <= 12 ? 3 : 4)))
        self.g = 	form.gcs <= 3 ? 0 : (form.gcs <= 5 ? 1 : (form.gcs <= 8 ? 2 : (form.gcs <= 12 ? 3 : 4)))

        // sbp == 0 ? 0 : (sbp <= 50 ? 1 : (sbp <= 75 ? 2 : (sbp < 90 ? 3 : 4)))
        self.p = form.sbp == 0 ? 0 : (form.sbp <= 50 ? 1 : (form.sbp <= 75 ? 2 : (form.sbp < 90 ? 3 : 4)))

	      // rr < 1 ? 0 : (rr <= 5 ? 1 : (rr <= 9 ? 2 : (rr <= 29 ? 4 : 3)))
        self.r = 	form.rr < 1 ? 0 : (form.rr <= 5 ? 1 : (form.rr <= 9 ? 2 : (form.rr <= 29 ? 4 : 3)))

        // g + p + r  form.
        let result = self.g + self.p + self.r 

        // (0.9368 * g) + (0.7326 * p) + (0.2908 * r)
        let rts= (0.9368 * self.g) + (0.7326 * self.p) + (0.2908 * self.r)
        self.rts = String(rts.toFixed(2))

        if (rts < 4) {
          self.descTxt = '求助创伤中心'
        }
        self.hasScore = true
        return String(result)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Trauma/RevisedTraumaScore.vue